import script from "./LandingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingView.vue?vue&type=script&setup=true&lang=ts"

import "./LandingView.vue?vue&type=style&index=0&id=31dd1a6c&lang=css"

const __exports__ = script;

export default __exports__